import { useState, useEffect } from 'react';
export const useOfficeHost = () => {
    const [hostType, setHostType] = useState(null);
    const [isInitialized, setIsInitialized] = useState(false);
    useEffect(() => {
        const detectHost = () => {
            try {
                if (typeof Office !== 'undefined' && Office.context && Office.context.host) {
                    setHostType(Office.context.host);
                }
                setIsInitialized(true);
            }
            catch (error) {
                console.warn('Failed to detect Office host:', error);
                setIsInitialized(true);
            }
        };
        // Check if Office is already ready
        if (typeof Office !== 'undefined' && Office.context) {
            detectHost();
        }
        else {
            // Wait for Office to be ready
            if (typeof Office !== 'undefined') {
                Office.onReady(() => {
                    detectHost();
                });
            }
            else {
                setIsInitialized(true);
            }
        }
    }, []);
    return {
        hostType,
        isInitialized,
        isOutlook: hostType === Office.HostType.Outlook,
        isWord: hostType === Office.HostType.Word,
        isPowerPoint: hostType === Office.HostType.PowerPoint,
    };
};
